import chroma from "chroma-js";
import { hexToCSSFilter } from "hex-to-css-filter";

let colorCache = {};

export function darken(color, perc) {
  if (!colorCache[`${color}:${perc}`]) {
    colorCache[`${color}:${perc}`] = chroma(color).darken(perc).hex();
  }
  return colorCache[`${color}:${perc}`];
}

export function brighten(color, perc) {
  if (!colorCache[`${color}:${perc}`]) {
    colorCache[`${color}:${perc}`] = chroma(color).brighten(perc).hex();
  }
  return colorCache[`${color}:${perc}`];
}

export function toFilter(color) {
  if (!colorCache[color]) {
    colorCache[color] = hexToCSSFilter(chroma(color).hex()).filter;
  }
  return colorCache[color];
}

export function palette(color) {
  if (!colorCache[color]) {
    colorCache[color] = chroma
      .scale(["white", color, "black"])
      .colors(11)
      .slice(1, 9);
  }
  return colorCache[color];
}

export async function isCSSFile(url) {
  const resp = await fetch(url);
  const content = await resp.text();
  const contentType = resp.headers.get("content-type");
  return contentType === "text/css" || content.indexOf("@font-face") >= 0
    ? content
    : false;
}

export const getValue = (key, meta, autoPriority) => {
  const obj = meta[key];
  if (obj.value) {
    return obj.value;
  }
  if (!autoPriority && obj.ref) {
    return getValue(obj.ref, meta);
  }
  if (obj.valueFunc) {
    return obj.valueFunc(meta);
  }
  if (autoPriority && obj.ref) {
    return getValue(obj.ref, meta);
  }
  return obj.defaultValue;
};
